export var SxSReadingPaneMode;
(function (SxSReadingPaneMode) {
    SxSReadingPaneMode[SxSReadingPaneMode["ConversationReadingPane"] = 0] = "ConversationReadingPane";
    SxSReadingPaneMode[SxSReadingPaneMode["ItemReadingPane"] = 1] = "ItemReadingPane";
})(SxSReadingPaneMode || (SxSReadingPaneMode = {}));
//# sourceMappingURL=SxSReadingPaneState.js.map